import React from 'react';
import { Col } from 'react-bootstrap';

const fiftyYears = () => {
    return (
        <Col md="12" >
        <article>
          <div className="info-box">
        <h2>50 YEARS OF SOFTAC</h2>
            After <strong>50 years</strong> of service, SOFTAC has
            honed its skills in many industries and has
            delivered automated solutions to
            thousands of businesses across the world.
            Centrally located in the Fraser Valley of British
            Columbia, our team has developed key
            partnerships with global leaders - both
            customers and vendors.
            Our CSA/UL certified control panel shop employs
            unprecedented manufacturing methodologies
            & processes designed to build in repeatability,
            quality and eliminate waste so you don’t pay
            more than is necessary without compromising
            value and performance.
            
        </div>
        </article>
        </Col>
    );
  }
export default fiftyYears;
